import { Component,Input } from '@angular/core';

@Component({
    selector: 'icon-close',
    templateUrl: './close.component.html',
    styleUrls: ['./close.component.css'],
    standalone: false
})
export class CloseComponent {
  @Input() size=24;
  @Input() color='#000';
}
